module.exports = __webpack_public_path__ + "img/passo_01.d27739c8.png";